/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Scim_Contact_SalesInputs */



/**
* | output |
* | --- |
* | "Contact Sales" |
*
* @param {Admin_Settings_Scim_Contact_SalesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_scim_contact_sales = /** @type {((inputs?: Admin_Settings_Scim_Contact_SalesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Scim_Contact_SalesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertrieb kontaktieren")
	return /** @type {LocalizedString} */ ("Contact Sales")
});